"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEDDConfig = void 0;
const client_1 = require("@apollo/client");
const use_edd_config_graphql_1 = require("./use-edd-config.graphql");
const AccountContext_1 = require("contexts/AccountContext");
const useEDDConfig = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const getEDDConfig = (0, client_1.useQuery)(use_edd_config_graphql_1.GET_EDD_CONFIG, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        variables: { accountId: account.id },
        fetchPolicy: 'network-only',
        skip: !(account === null || account === void 0 ? void 0 : account.id)
    });
    const { error, loading, data, refetch } = getEDDConfig;
    const eddConfig = (data === null || data === void 0 ? void 0 : data.estimatedDeliveryDateConfig) || null;
    return {
        error,
        loading,
        config: eddConfig,
        refetch
    };
};
exports.useEDDConfig = useEDDConfig;
